// Simple localStorage-backed persistence for audio preferences

const MUTE_KEY = 'audio.muted';
const VOLUME_KEY = 'audio.volume';

export function loadMuted(): boolean {
  try {
    const v = localStorage.getItem(MUTE_KEY);
    return v === '1' || v === 'true';
  } catch {
    return false;
  }
}

export function saveMuted(muted: boolean): void {
  try {
    localStorage.setItem(MUTE_KEY, muted ? '1' : '0');
  } catch {
    // ignore storage failures (private mode, etc.)
  }
}

export function loadVolume(): number | undefined {
  try {
    const v = localStorage.getItem(VOLUME_KEY);
    if (v == null) return undefined;
    const n = Number(v);
    return Number.isFinite(n) ? n : undefined;
  } catch {
    return undefined;
  }
}

export function saveVolume(vol01: number): void {
  try {
    localStorage.setItem(VOLUME_KEY, String(Math.max(0, Math.min(1, vol01))));
  } catch {
    // ignore
  }
}